import styled from 'styled-components';
import { palette } from '../../theme/colors';

export const SContainer = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: ${palette.darkGold};
  border: none;
  border-bottom: 1px solid ${palette.gold};
  cursor: pointer;
  text-align: left;

  &:active {
    opacity: 0.8;
  }
`;

export const SIcon = styled.span`
  display: inline-flex;
  flex-shrink: 0;

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const STextColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const STitle = styled.span`
  color: ${palette.white};
  font-size: 13px;
  font-family: 'Roboto-Medium';
  line-height: 18px;
`;

export const SLearnMore = styled.span`
  color: ${palette.gold};
  font-size: 13px;
  font-family: 'Roboto-Regular';
  line-height: 18px;
  text-decoration: underline;
`;
